import React from 'react';
import { scrollToCompra } from '../utils/scroll';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  href?: string;
  className?: string;
  pulse?: boolean;
  fullWidth?: boolean;
  variant?: 'green' | 'gold' | 'red';
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  pulse = true,
  fullWidth = true,
  variant = 'green'
}: ButtonProps) {
  const variantClasses = {
    green: 'bg-brand-cta hover:bg-brand-ctaDark text-white cta-shadow border-b-4 border-brand-ctaDark',
    gold: 'bg-brand-yellowDark hover:bg-brand-gold text-brand-navy gold-shadow border-b-4 border-brand-gold',
    red: 'bg-brand-red hover:bg-brand-redDark text-white border-b-4 border-brand-redDark'
  }[variant];
  const baseClasses = 'relative inline-flex items-center justify-center font-display font-bold transition-all duration-200 rounded-md px-5 py-3.5 md:px-7 md:py-4 text-base md:text-lg lg:text-2xl text-center uppercase tracking-wide active:translate-y-[3px]';
  const pulseClasses = pulse ? 'animate-pulse-fast hover:animate-none' : '';
  const widthClasses = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) onClick(e);else if (!href) scrollToCompra(e);
  };
  if (href) {
    return <a href={href} className={`${baseClasses} ${variantClasses} ${pulseClasses} ${widthClasses} ${className}`} target="_blank" rel="noopener noreferrer" data-id="element-39">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={`${baseClasses} ${variantClasses} ${pulseClasses} ${widthClasses} ${className}`} data-id="element-40">
      {children}
    </button>;
}